import Error from '../model/Error';
import ProblemVisibility from '../dto/ProblemVisibility';
import axios from 'axios';

export default class ProblemVisibilityRepository {

    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/kindergartens/' + kindergartenId + '/problem-visibilities')
                .then(response => resolve(response.data.data.map(data => ProblemVisibility.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(kindergartenId, visibilities) {
        return new Promise((resolve, reject) => {
            axios
                .put('/kindergartens/' + kindergartenId + '/problem-visibilities', {visibilities})
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
